import { useEffect, useState } from "react";
import type { Locale } from "@twm/shared";
import { initialAdminLanguage } from "./language-preference";

export function useAdminLanguage() {
  const [lang, setLang] = useState<Locale>(() => initialAdminLanguage(window.location.search, localStorage.getItem("twm-admin-lang")));
  useEffect(() => {
    localStorage.setItem("twm-admin-lang", lang); document.documentElement.lang = lang;
    const url = new URL(window.location.href);
    if (url.searchParams.has("lang")) {
      url.searchParams.delete("lang");
      window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`);
    }
  }, [lang]);
  return { lang, setLang };
}
